"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("StateSelector");

var AccountActions = require("./AccountActions");
var AccountConstants = require("./AccountConstants");
var AccountFormHelper = require("./AccountFormHelper");
var AccountStore = require("./AccountStore");

class StateSelector extends React.Component {
	constructor(props) {
		super(props);

		var stateConfig = props.stateConfig || {};

		var wizardCountryStateList;
		var isAddressVerificationEnabled;
		var restrictedCountries;
		var alreadyDefaultedStatesFromWizard = false;

		// If we are on the client side
		if (typeof (window) !== "undefined") {
			wizardCountryStateList = AccountStore.get("wizardCountryStateList");
			var addressStandardizationWizard = AccountStore.get("wizardAddressStandardization");
			isAddressVerificationEnabled = addressStandardizationWizard && addressStandardizationWizard.isEnabled === "true";
			restrictedCountries = addressStandardizationWizard && addressStandardizationWizard.restrictedCountries;

			if (!Object.keys(stateConfig).length) {
				//This means we do not have the config set up yet.
				Object.keys(wizardCountryStateList).forEach(key => {
					if (key && key.indexOf("_Description") === -1) {
						key = key.toUpperCase();
						stateConfig[key] = Array.isArray(wizardCountryStateList[key]) ? wizardCountryStateList[key].map(availableState => {
							return {
								value: availableState,
								description: wizardCountryStateList[`${key}_${availableState}_Description`],
								useDefaultDescription: true
							};
						}) : undefined
					}
				});
				alreadyDefaultedStatesFromWizard = true;
			}
		}

		//Making sure the Country Value Properties are uppercase
		Object.keys(stateConfig).forEach((key) => {
			if (key && key.indexOf("_Description") === -1) {
				var upperCaseKey = key.toUpperCase();

				if (upperCaseKey !== key) {
					stateConfig[upperCaseKey] = stateConfig[key];
					delete stateConfig[key];
				}
			}
		});

		if (wizardCountryStateList && !alreadyDefaultedStatesFromWizard) {
			Object.keys(wizardCountryStateList).forEach(key => {
				if (key && key.indexOf("_Description") === -1) {
					key = key.toUpperCase();
					var allowedStates = wizardCountryStateList[key];
					var availableStates = stateConfig[key];

					if (!availableStates || !availableStates.length) {
						return;
					}

					var availableState;
					for (var index = availableStates.length - 1; index >= 0; --index) {
						availableState = availableStates[index];
						var allowedIndex = allowedStates.indexOf(availableState.value);
						if (allowedIndex === -1) {
							// AvailableState is not allowed
							availableStates.splice(index, 1);
						} else if (availableState.useDefaultDescription) {
							// AvailableState should use default description
							availableState.description = wizardCountryStateList[`${key}_${availableState.value}_Description`];
						}
					}
				}
			});
		}

		this.state = {
			selectedState: props.initialValue || "",
			stateConfig,
			disabled: false,
			inputType: props.initialInputType || "select",
			isAddressVerificationEnabled,
			restrictedCountries: restrictedCountries || [],
			placeholderText: props.placeholderText
		};

		this._onChange = this._onChange.bind(this);
	}

	handleStateSelected(event) {
		if (!event || !event.currentTarget) {
			return;
		}

		var selectedState = event.currentTarget.value ;

		var formParentId = AccountFormHelper.getParentFormId(this);
		AccountActions.setSelectedState(formParentId, selectedState);
	}

	handleModifierSelectedChange(modifierSelected) {
		this.setState({
			inputType: (modifierSelected === "text") ? "text" : "select"
		});
	}

	updatePropsForRemounting(properties) {
		properties = properties || {};
		properties.initialInputType = this.state.inputType;
		return properties;
	}

	_onChange() {
		if (this._isMounted) {
			var formParentId = AccountFormHelper.getParentFormId(this);
			this.setState({
				selectedCountry: AccountActions.getSelectedCountry(formParentId),
				selectedState: AccountActions.getSelectedState(formParentId) || "",
				disabled: formParentId ? AccountActions.getIsFormInputDisabled(formParentId) : false
			}, () => {
				if (!this.props.isDesignMode) {
					if (!this.state.stateConfig[this.state.selectedCountry] || !this.state.stateConfig[this.state.selectedCountry].length) {
						// If there are no states to select from and the selector is also marked as invalid,
						// remove the "invalid" class so the constituent won't be frustrated trying to set a
						// value for a field which is disabled.
						$(ReactDOM.findDOMNode(this)).find("select.invalid").removeClass("invalid");

						// We only allow switching to text input if we are configured for address standardization and auto-adding states and postal codes.
						var isStandardizableCountry = () => !this.state.restrictedCountries.some(restrictedCountry => restrictedCountry === this.state.selectedCountry);
						if (this.state.isAddressVerificationEnabled && AccountActions.getIsAutoAddStateAndPostalCodes() && isStandardizableCountry()) {
							if (this.state.inputType === "select") {
								this.setState({
									inputType: "text",
									selectedState: ""
								});
							}
						}
					} else {
						this.setState({
							inputType: "select"
						});
					}
				}
			});
		}
	}

	componentDidMount() {
		this._isMounted = true;

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this);
		}

		var $formParent = AccountFormHelper.getParentForm(this);
		var formParentId = AccountFormHelper.getParentFormIdFromForm($formParent);
		var updateAllowed = true;

		if ($formParent.length > 0) {
			// updateAllowed only applies to createAccountForm
			updateAllowed = !$formParent.is("[data-component='createAccountForm']") || $formParent.is("[data-update-allowed]");
		}

		AccountActions.toggleInputStatus(formParentId, /*disabled*/ !updateAllowed);

		//Setting the selectedState in state initially.
		AccountActions.setSelectedState(formParentId, this.state.selectedState);
		this._onChange();
		AccountStore.addSpecificListener(AccountConstants.SET_SELECTED_STATE, this._onChange);
		AccountStore.addSpecificListener(AccountConstants.SET_SELECTED_COUNTRY, this._onChange);
		AccountStore.addSpecificListener(AccountConstants.SET_AUTO_ADD_STATE_AND_POSTAL_CODES, this._onChange);
	}

	componentWillUnmount() {
		AccountStore.removeSpecificListener(AccountConstants.SET_SELECTED_STATE, this._onChange);
		AccountStore.removeSpecificListener(AccountConstants.SET_SELECTED_COUNTRY, this._onChange);
		AccountStore.removeSpecificListener(AccountConstants.SET_AUTO_ADD_STATE_AND_POSTAL_CODES, this._onChange);
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this);
		}

		this._isMounted = false;
	}

	render() {
		var availableStates = this.state.stateConfig[this.state.selectedCountry];
		var disabled = this.state.disabled || (!this.props.isDesignMode && (!availableStates || !availableStates.length));
		var isSelect = this.state.inputType === "select";
		var placeholderText = this.state.placeholderText;

		var textStyle = this.props.isDesignMode ? { pointerEvents: "none" } : {};
		if (this.state.selectedState) {
			textStyle.textTransform = "uppercase";
		}

		return (
			<div
				data-react-component-name="StateSelector"
				data-component-id={!this.props.isCustomTheme ? this.props.dataComponentId : undefined}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
				data-react-component-category={this.props.reactComponentCategory}
			>
				<select
					className={classNames("state-selector form-control", this.props.childClass, { hidden: !isSelect })}
					style={this.props.isDesignMode ? { pointerEvents: "none" } : undefined}
					data-override-classes={this.props.childClass}
					disabled={disabled}
					name={isSelect ? "address.state" : "address.state.inactive"} // we change the name to ensure related selectors only find the active input
					data-shared-name={"address.state.field"}
					onChange={this.handleStateSelected.bind(this)}
					data-required={this.props.dataRequired}
					required={this.props.required || this.props.dataRequired}
					value={this.state.selectedState}
				>
					<option value=""></option>
					{availableStates && availableStates.map((availableState) => {
						return (
							<option className="availableState" key={availableState.value} value={availableState.value}>
								{availableState.description}
							</option>
						);
					})}
				</select>
				<input
					className={classNames("state-selector form-control", this.props.childClass, { hidden: isSelect })}
					type="text"
					name={!isSelect ? "address.state" : "address.state.inactive"} // we change the name to ensure related selectors only find the active input
					data-shared-name={"address.state.field"}
					style={textStyle}
					data-override-classes={this.props.childClass}
					maxLength={this.props.isDesignMode ? undefined : "3"} // We only allow users to input state codes. Entering placeholder text in the designer should not be limited to 3 characters.
					onBlur={this.handleStateSelected.bind(this)}
					onChange={this.handleStateSelected.bind(this)}
					data-required={this.props.dataRequired}
					required={this.props.required || this.props.dataRequired}
					value={this.state.selectedState}
					placeholder={placeholderText}
				/>
			</div>
		);
	}
}

StateSelector.propTypes = {
	isDesignMode: PropTypes.bool,
	stateConfig: PropTypes.object,
	dataRequired: PropTypes.bool,
	required: PropTypes.bool,
	theme: PropTypes.string,
	context: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	reactComponentCategory: PropTypes.string,
	initialValue: PropTypes.string,
	dataChildOf: PropTypes.string
};

module.exports = StateSelector;
